import { useState } from "react";
import { Star } from "lucide-react";

export const StarRating = ({ value, onChange, readonly = false, size = "md" }) => {
  const [hovered, setHovered] = useState(0);
  const starSize = size === "sm" ? "w-4 h-4" : "w-5 h-5";

  return (
    <div className="flex gap-0.5">
      {[1, 2, 3, 4, 5].map((star) => (
        <button
          key={star}
          type="button"
          disabled={readonly}
          onClick={() => !readonly && onChange?.(star)}
          onMouseEnter={() => !readonly && setHovered(star)}
          onMouseLeave={() => setHovered(0)}
          className={`${readonly ? 'cursor-default' : 'cursor-pointer transition-transform hover:scale-110'}`}
        >
          <Star
            className={`${starSize} ${star <= (hovered || value) ? 'text-primary fill-primary' : 'text-muted'}`}
          />
        </button>
      ))}
    </div>
  );
};
